import React, { Component, Suspense, useEffect, useState } from 'react'
import { HashRouter, Route, Routes, useNavigate, Navigate, useLocation } from 'react-router-dom'
import '../scss/style.scss'
import { useAuth } from 'src/hooks/auth'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('../layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('../views/pages/login/Login'))
const Register = React.lazy(() => import('../views/pages/register/Register'))
const Page404 = React.lazy(() => import('../views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('../views/pages/page500/Page500'))

function RoutesApp() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!user.user || !user.user.id) {
      navigate('/login')
    }
  }, [pathname])

  useEffect(() => {
    sessionStorage.removeItem('pageSize')
  }, [pathname])

  return (
    <Routes>
      <Route exact path="/login" name="Login Page" element={<Login />} />
      {user && user.user && user.user.id ? (
        <Route path="*" name="Home" element={<DefaultLayout />} />
      ) : (
        <Route path="/login" element={<Navigate to="/login" />} />
      )}
      <Route exact path="/register" name="Register Page" element={<Register />} />
      <Route exact path="/404" name="Page 404" element={<Page404 />} />
      <Route exact path="/500" name="Page 500" element={<Page500 />} />
    </Routes>
  )
}

export default RoutesApp
